import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import useResource from 'Hooks/useResource';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import MetaControl from 'Components/UI/Meta/MetaControl';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputContainer: {
    padding: theme.spacing(1, 0),
  },
  input: {
  },
}));
function MeetingTemplateDialog({
  template, onSave, onCancel, saveLabel, isValidTemplateName,
}) {
  const classes = useStyles();
  const { resource, setAttribute } = useResource(template);
  const handleUpdate = (attrName, v) => {
    setAttribute(attrName, v);
  };

  const nameIsValid = isValidTemplateName(resource.attr('name'));
  if (!resource) return null;
  return (
    <Dialog
      maxWidth="xs"
      title="Meeting Email Template"
      open
      onClose={onCancel}
    >
      <DialogContent>
        <DialogTitle>What should we call your template?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            This template will only be available to you
          </Typography>
          <div className={classes.inputContainer}>
            <MetaControl
              error={!nameIsValid}
              helperText={!nameIsValid ? 'This name is already taken' : ''}
              className={classes.input}
              attrName="name"
              resource={resource}
              onChange={(value) => {
                handleUpdate('name', value);
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="text" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            color="primary"
            disableElevation
            variant="contained"
            disabled={!nameIsValid}
            onClick={() => onSave(resource)}
          >
            {saveLabel}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

MeetingTemplateDialog.propTypes = {
  template: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  saveLabel: PropTypes.string,
  isValidTemplateName: PropTypes.func,
};

MeetingTemplateDialog.defaultProps = {
  onSave: () => {},
  onCancel: () => {},
  saveLabel: 'Save',
  isValidTemplateName: () => true,
};

export default MeetingTemplateDialog;
